'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionGrade = function ActionGrade(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
  );
};
ActionGrade = (0, _pure2.default)(ActionGrade);
ActionGrade.displayName = 'ActionGrade';
ActionGrade.muiName = 'SvgIcon';

exports.default = ActionGrade;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/grade.js
 ** module id = 471
 ** module chunks = 0
 **/